/**
 * Workspace alias condition alias
 */
export const UMB_WORKSPACE_CONDITION_ALIAS = 'Umb.Condition.WorkspaceAlias';
